/**
 * Dependency Injection Module: Tiering Settings
 * Mirrors Dashboard DI structure; currently wires repository to mock implementation.
 */

import { Container } from "inversify";
import type { ITieringSettingsRepository } from "../domain/repository/ITieringSettingsRepository";
import { TieringSettingsRepositoryImpl } from "../data/repository/TieringSettingsRepositoryImpl";
import { TieringSettingsApiService } from "../data/remote/service/TieringSettingsApiService";

const TYPES = {
	ITieringSettingsRepository: Symbol.for("ITieringSettingsRepository"),
};

const tieringSettingsContainer = new Container();

tieringSettingsContainer
	.bind<ITieringSettingsRepository>(TYPES.ITieringSettingsRepository)
	.to(TieringSettingsRepositoryImpl)
	.inSingletonScope();

tieringSettingsContainer
	.bind(TieringSettingsApiService)
	.toSelf()
	.inSingletonScope();

export { tieringSettingsContainer, TYPES };

